import get from "lodash/get";
import { EMPTY_STRING, INDEX } from "../constants";

const { SECOND } = INDEX;

const validateServiceDeletion = (row, setAlertData) => {
  let linkedEntity;
  const serviceType = row.serviceType === "endpoint" ? "endpoints" : "backgroundTasks";
  const entity = serviceType === "endpoints" ? "endpoint" : "background task";
  const isSingleEntity = row[serviceType].length === 1;
  if (isSingleEntity) linkedEntity = get(row, [serviceType, "0", "name"]);
  else
    linkedEntity = row[serviceType].reduce((acc, { name }, index, arr) => {
      if (index === arr.length - SECOND) return `${acc.slice(0, -1)} & ${name}`;
      return `${acc} ${name},`;
    }, EMPTY_STRING);
  const entityPlural = isSingleEntity ? EMPTY_STRING : "s";
  setAlertData({
    message: `This service is linked with ${entity}${entityPlural}: ${linkedEntity}. \n Please delete the dependent ${entity}${entityPlural} first, then you can delete this service.`,
  });
};

export default validateServiceDeletion;
